import { Link } from "react-router-dom";
import { AudioLines } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1704643770744-154e115d454d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMHNvdW5kJTIwd2F2ZXxlbnwwfHx8fDE3ODkyNTI5MTV8MA&ixlib=rb-4.1.0&q=85";

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-background/70" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <Link to="/" className="flex items-center gap-2.5 w-fit">
            <span className="grid place-items-center h-9 w-9 rounded-full bg-primary/20 text-primary"><AudioLines size={20} strokeWidth={1.5} /></span>
            <span className="font-serif text-xl">VoiceMatrix AI</span>
          </Link>
          <div>
            <h2 className="font-serif text-4xl leading-tight max-w-md">Your voice carries the frequency of your wellbeing.</h2>
            <p className="text-muted-foreground mt-4 max-w-sm">Map it in 30 seconds. Track it over time. Always confirm with your physician.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2.5 mb-8">
            <span className="grid place-items-center h-9 w-9 rounded-full bg-primary/20 text-primary"><AudioLines size={20} strokeWidth={1.5} /></span>
            <span className="font-serif text-xl">VoiceMatrix AI</span>
          </Link>
          <h1 className="font-serif text-3xl tracking-tight mb-2">{title}</h1>
          <p className="text-muted-foreground text-sm mb-8">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
